<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{group.name}}</span>
        <v-spacer></v-spacer>
        <v-btn @click="goReadonly" color="primary" flat small v-if="editing">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="py-0" fluid grid-list-md>
          <v-layout class="mb-4" wrap>
            <v-flex sm6 xs12>
              <v-text-field
                :label="typeName + '名称'"
                prepend-icon="$vuetify.icons.group"
                v-model="group.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <l-autocomplete
                :disabled="status==='edit'"
                :dense="true"
                item-text="name"
                :get-data="getParent"
                :hint="`为空将添加到顶级${typeName}`"
                :label="'父级' + typeName"
                persistent-hint
                prepend-icon="$vuetify.icons.group"
                v-model="group.parent"
              ></l-autocomplete>
            </v-flex>
            <v-flex sm4 xs6>
              <v-text-field
                disabled
                :label="typeName + '级别'"
                prepend-icon="$vuetify.icons.level"
                v-model="group.level"
                persistent-hint
                :hint="`系统根据父级${typeName}生成`"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs6>
              <v-text-field
                disabled
                :label="typeName + '代码'"
                prepend-icon="$vuetify.icons.levelCode"
                v-model="group.code"
                persistent-hint
                :hint="`系统根据父级${typeName}生成`"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs12>
              <v-select
                :disabled="isOrg"
                :hint="isOrg || editing ? '':'可选'"
                :items="groupTypes"
                :label="'分组类型'"
                item-text="description"
                multiple
                persistent-hint
                prepend-icon="$vuetify.icons.group"
                return-object
                v-model="group.typeList"
                @change="changeGroupType"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :label="typeName + '描述'"
                :rows="1"
                auto-grow
                prepend-icon="$vuetify.icons.description"
                v-model="group.description"
              ></v-textarea>
            </v-flex>
            <v-layout row  wrap>
              <v-flex xs12>
                <v-textarea
                  auto-grow
                  label="进场屏显提示词"
                  prepend-icon="$vuetify.icons.led"
                  rows="1"
                  v-model="group.osdMsgIn"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  auto-grow
                  label="进场语音提示词"
                  prepend-icon="$vuetify.icons.audio"
                  rows="1"
                  v-model="group.vcbMsgIn"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  auto-grow
                  label="出场屏显提示词"
                  prepend-icon="$vuetify.icons.led"
                  rows="1"
                  v-model="group.osdMsgOut"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  auto-grow
                  label="出场语音提示词"
                  prepend-icon="$vuetify.icons.audio"
                  rows="1"
                  v-model="group.vcbMsgOut"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-flex v-if="editing" xs12>
              <v-btn
                :loading="submitLoading"
                @click="setGroup(group)"
                class="mx-0"
                color="primary"
                flat
              >提交更改
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout column>
            <v-checkbox
              v-show="showPassGroup"
              v-model="needNewPassGroup"
              label="是否建立通行分组"
            ></v-checkbox>
            <v-form ref="passGroupForm" v-show="needNewPassGroup">
              <template>
                <v-flex v-for="(c,key,i) in passGroupForm" :key="key" xs12>
                  <v-text-field v-if="c.type==='input'" :label="c.label" :prepend-icon="c.icon"
                                v-model="c.value"></v-text-field>
                  <l-select-datetime v-if="c.type==='date'" :label="c.label" v-model="c.value"></l-select-datetime>
                </v-flex>
              </template>
            </v-form>
          </v-layout>
          <v-subheader>绑定角色</v-subheader>
          <v-layout class="mb-4" wrap>
            <v-flex xs12>
              <l-data-table
                :headers="roleHeaders"
                :items="group.roleList"
                auto-actions
                flat
                hide-headers
                hide-title
                no-data-text="没有绑定角色"
              >
                <template slot="row-action" slot-scope="{item}">
                  <td @click.stop class="px-0 mx-0 text-xs-right">
                    <v-btn @click="deleteRole(item)" icon>
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </l-data-table>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="openRoleDialog" class="mx-0" color="primary" flat>添加角色</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-expand-transition>
          <v-container class="pt-0" fluid grid-list-md v-if="showUser && editing">
            <v-subheader>绑定用户</v-subheader>
            <v-layout class="mb-4" wrap>
              <v-flex xs12>
                <l-data-table
                  :get-data-func="getBindUsers"
                  :headers="userHeaders"
                  auto-actions
                  flat
                  hide-title
                  no-data-text="没有绑定用户"
                  ref="userList"
                >
                  <template slot="row-action" slot-scope="{item}">
                    <td @click.stop class="px-0 mx-0 text-xs-right">
                      <v-btn @click="deleteUser(item)" icon>
                        <v-icon small>$vuetify.icons.delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </l-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn @click="openUserDialog" class="mx-0" color="primary" flat>添加用户</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expand-transition>
        <v-layout v-if="editing">
          <v-flex class="text-xs-center">
            <v-btn @click="showUser = !showUser" color="primary" flat>{{showUser ? '收起':'管理'}}已绑定用户</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout class="mt-2" v-if="newItem">
      <v-flex class="text-xs-right">
        <v-btn :loading="submitLoading" @click="newGroup(group)" class="mx-0" color="primary">提交</v-btn>
      </v-flex>
    </v-layout>
    <l-dialog
      :auto-close="newItem"
      :loading="roleDialog.loading"
      @cancel="closeRoleDialog"
      @confirm="addRoles(roleDialog.roles)"
      hide-divider
      max-width="500px"
      title="添加角色"
      v-model="roleDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :get-data="searchRoles"
          item-text="name"
          label="添加角色"
          multiple
          prepend-icon="$vuetify.icons.role"
          v-model="roleDialog.roles"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
    <l-dialog
      :auto-close="newItem"
      :loading="userDialog.loading"
      @cancel="closeUserDialog"
      @confirm="addUsers(userDialog.users)"
      hide-divider
      max-width="500px"
      title="添加用户"
      v-if="editing"
      v-model="userDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :get-data="searchUsers"
          item-text="name"
          item-value="id"
          item-sub-text="loginId"
          label="添加用户"
          multiple
          :init-data="false"
          prepend-icon="$vuetify.icons.person"
          v-model="userDialog.users"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils'
import {Group} from '../../../object'
import LSelectDatetime from '../../../ladmin/components/LSelectDatetime/LSelectDatetime'

export default {
  name: 'groupForm',
  components: {LSelectDatetime},
  props: {
    type: {type: String, default: ''},
    group: {type: Object, default: () => (new Group())},
    status: {type: String, default: ''}
  },
  data: () => ({
    submitLoading: false,
    showUser: false,
    roleDialog: {
      activate: false,
      roles: [],
      loading: false
    },
    userDialog: {
      activate: false,
      users: [],
      loading: false
    },
    roleHeaders: [
      {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
    userHeaders: [
      {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
    needNewPassGroup: false,
    showPassGroup: false,
    passGroupForm: {
      obgrpName: {value: '', type: 'input', icon: '$vuetify.icons.title', label: '分组名称'},
      obgrpDesc: {value: '', type: 'input', icon: '$vuetify.icons.description', label: '分组描述'},
      obgrpVali: {value: '2036-12-31 00:00', type: 'date', icon: '', label: '分组过期时间'},
      osdMsgIn: {value: '登记车辆|减速慢行|欢迎光临', type: 'input', icon: '$vuetify.icons.led', label: '进场屏幕显示'},
      osdMsgOut: {value: '登记车辆|减速慢行|一路平安', type: 'input', icon: '$vuetify.icons.led', label: '出场屏幕显示'},
      vcbMsgIn: {value: '登记车辆欢迎光临', type: 'input', icon: '$vuetify.icons.audio', label: '进场语音提示'},
      vcbMsgOut: {value: '登记车辆移路平安', type: 'input', icon: '$vuetify.icons.audio', label: '出场语音提示'}
    }
  }),
  computed: {
    groupTypes () {
      return this.$store.state.userAdmin.groupTypes
    },
    newItem () {
      return this.$route.name === 'NewGroup' || this.$route.name === 'NewOrg'
    },
    editing () {
      return this.$route.name === 'EditGroup' || this.$route.name === 'EditOrg'
    },
    isOrg () {
      return this.type === Group.ORGANIZATION
    },
    typeName () {
      if (this.isOrg) {
        return '单位'
      }
      else {
        return '分组'
      }
    }
  },
  watch: {
    groupTypes (val) {
      if (!val.length) {
        this.getGroupTypes()
      }
    },
    'group.typeList': function (val) {
      let res = this.group.typeList.filter((v) => v.name === 'reg')
      if (res.length === 0) {
        this.showPassGroup = false
      }
      else {
        this.showPassGroup = true
      }
    }
  },
  methods: {
    async changeGroupType (e) {
      if (!this.isOrg && this.editing) {
        try {
          await this.$store.dispatch('userAdmin/groupBindGroupTypes', {group: this.group, types: e})
        }
        catch (e) {
          this.$L.error(e.message)
        }
      }
    },
    async getParent (searchValue) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getGroups', {
          pagination: {rowsPerPage: 100},
          search: {key: 'name', value: searchValue}
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      return []
    },
    async getGroupTypes () {
      try {
        await this.$store.dispatch('userAdmin/getGroupTypes', {
          pagination: {page: 1, rowsPerPage: 100, sortBy: 'name'}
        })
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    async newGroup (group) {
      this.submitLoading = true
      let passGroup = {
        obgrpName: this.passGroupForm.obgrpName.value,
        obgrpDesc: this.passGroupForm.obgrpDesc.value,
        obgrpVali: this.passGroupForm.obgrpVali.value,
        osdMsgIn: this.passGroupForm.osdMsgIn.value,
        osdMsgOut: this.passGroupForm.osdMsgOut.value,
        vcbMsgIn: this.passGroupForm.vcbMsgIn.value,
        vcbMsgOut: this.passGroupForm.vcbMsgOut.value
      }
      let newGroup = await this.setGroup(group, passGroup)
      console.log(newGroup)
      if (newGroup) {
        await this.$L.tab.close(this.$L.tab.current, false)
        this.$router.push({
          name: this.isOrg ? 'OrganizationList' : 'GroupList',
          params: {refresh: true}
        })
      }
      this.submitLoading = false
    },
    async setGroup (group, passGroup) {
      let extend = {
        osdMsgIn: this.group.osdMsgIn,
        osdMsgOut: this.group.osdMsgOut,
        vcbMsgIn: this.group.vcbMsgIn,
        vcbMsgOut: this.group.vcbMsgOut
      }
      group.extend = JSON.stringify(extend)
      // console.log(group)
      try {

        this.submitLoading = true
        let res = await this.$store.dispatch('userAdmin/setGroup', {group: group, passGroup: passGroup})
        this.$L.alert('success', '提交成功')
        return res
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    openRoleDialog () {
      this.roleDialog = {
        activate: true,
        roles: [],
        loading: false
      }
    },
    closeRoleDialog () {
      this.roleDialog = {
        activate: false,
        roles: [],
        loading: false
      }
    },
    async addRoles (roles) {
      if (this.newItem) {
        this.group.addRole(...roles)
      }
      else {
        this.roleDialog.loading = true
        try {
          await this.$store.dispatch('userAdmin/groupBindRoles', {group: this.group, roles})
          this.$emit('refresh')
          this.closeRoleDialog()
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
        finally {
          this.roleDialog.loading = false
        }
      }
    },
    async deleteRole (role) {
      if (this.newItem) {
        this.group.deleteRole(role)
      }
      else {
        let {res, close} = await this.$L.confirm({title: '确认删除', text: `确认删除角色${role.name}？`})
        try {
          if (res) {
            await this.$store.dispatch('userAdmin/groupUnbindRoles', {group: this.group, roles: [role]})
            this.$L.alert('success', '删除成功')
            this.$emit('refresh')
          }
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
        finally {
          close()
        }
      }
    },
    async searchRoles (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getRoles', {
          pagination: {page: 1, rowsPerPage: 10},
          search: {key: 'name', value: val || ''}
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    openUserDialog () {
      this.userDialog = {
        activate: true,
        users: [],
        loading: false
      }
    },
    closeUserDialog () {
      this.userDialog = {
        activate: false,
        users: [],
        loading: false
      }
    },
    async addUsers (users) {
      this.userDialog.loading = true
      try {
        await this.$store.dispatch('userAdmin/groupBindUsers', {group: this.group, users})
        this.$refs.userList.refresh()
        this.closeUserDialog()
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.userDialog.loading = false
      }
    },
    async deleteUser (user) {
      let {res, close} = await this.$L.confirm({title: '确认删除', text: `确认删除用户${user.name}？`})
      try {
        if (res) {
          await this.$store.dispatch('userAdmin/groupUnbindUsers', {group: this.group, users: [user]})
          this.$L.alert('success', '删除成功')
          this.$refs.userList.refresh()
        }
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        close()
      }
    },
    async searchUsers (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getUsers', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val || ''}
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    getBindUsers (params) {
      return this.$store.dispatch('userAdmin/getUsersByGroup', {params, group: this.group})
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: this.isOrg ? 'OrgDetails' : 'GroupDetails',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    },
    checkOrgType () {
      if (this.newItem && this.isOrg && !this.group.typeList.length) {
        let t = this.groupTypes.find(type => type.name === Group.ORGANIZATION)
        this.group.typeList = [t]
      }
    }
  },
  created () {
    // console.log(this.group)
    if (!this.groupTypes.length) {
      this.getGroupTypes().then(() => {
        this.checkOrgType()
      })
    }
    else {
      this.checkOrgType()
    }
    if (this.isOrg) {
      this.group.osdMsgIn = '合作单位用户|减速慢行|欢迎光临'
      this.group.osdMsgOut = '合作单位用户欢迎光临'
      this.group.vcbMsgIn = '合作单位用户|减速慢行|一路平安'
      this.group.vcbMsgOut = '合作单位用户移路平安'
    }
  }
}
</script>

<style scoped>

</style>
